<template>
  <div class="media-dialog" v-if="isVisible">
    <div class="media-dialog__body text-left">
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          v-loading="isBusy"
          element-loading-spinner="el-icon-loading"
      >
        <el-form-item prop="content">
          <el-input
              v-model="form.content"
              type="textarea"
              rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <button class="btn btn-secondary btn-sm px-4" @click="close">Cancel</button>
      <button class="btn btn-purple btn-sm px-4" @click="store" :disabled="!canStore">Save changes</button>
    </div>
  </div>
</template>

<script>
import eventBus from "../../event-bus";
import ValidatorMixin from "../../mixins/validator";

export default {
  data() {
    const form = {
      content: null,
    };
    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      message: null,
      url: null,
      errors: {},
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    isVisible() {
      return !_.isEmpty(this.message);
    },

    /**
     * @return {boolean}
     */
    canStore() {
      return this.message.content !== this.form.content;
    },
  },

  methods: {
    /**
     * @param {Object} message
     * @param {String} url
     */
    onEdit({message, url}) {
      this.message = message;
      this.form.content = message.content;
      this.url = url;
    },

    /**
     * @return {undefined}
     */
    store() {
      this.isBusy = true;
      axios.post(this.url, this.getForm(), this.getConfig())
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then((isBusy = false) => this.isBusy = isBusy);
    },

    /**
     * @return {Object}
     */
    getForm() {
      return _.assign({}, this.form, {
        _method: 'POST',
        id: _.get(this.message, 'id'),
      });
    },

    /**
     * @param {Object} res
     * @return {boolean}
     */
    storeSuccess({data: {data, message}}) {
      this.$emit('stored', data);
      _.isString(message) && this.$message.success(message);
      this.close();
    },

    /**
     * @param {Object} response
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}) {
      const {errors, message} = data || {};
      if (status === 422 && errors) {
        this.errors = errors;
        this.$refs.form.validate(() => null);
        this.$message.error(message);
      } else if (message && _.isString(message)) {
        this.$message.error(message);
      }

      return false;
    },

    /**
     * @return {undefined}
     */
    close() {
      this.message = this.form.content = this.url = null;
    },

    /**
     * @return {Object}
     */
    getConfig() {
      return {};
    },
  },

  mixins: [
    ValidatorMixin,
  ],

  /**
   * @return {undefined}
   */
  created() {
    eventBus.$on('on-message-edit', this.onEdit);
  },

  /**
   * @return {undefined}
   */
  beforeDestroy() {
    eventBus.$off('on-message-edit', this.onEdit);
  },
}
</script>

<style scoped>

</style>
